import React, {useState, useEffect} from 'react';
import { useRef } from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Button, Badge } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import * as url from 'helpers/url_helper';
import { Config, TOAST_OPTIONS, formatDate, encryptId } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, {PaginationListStandalone, PaginationProvider,} from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search, CSVExport } from 'react-bootstrap-table2-toolkit';

import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from 'react-select';

import PropTypes from 'prop-types';

import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import { useHistory } from 'react-router-dom';

    const WaterProduction = () => {

        const { ExportCSVButton } = CSVExport;
        const history = useHistory()

        toastr.options = TOAST_OPTIONS;

        const [dataList, setDataList] = useState([]);
        
        const [isloading, setIsloading] = useState(false);
        const [filterDate, setFilterDate] = useState('')

        const [sDate, setSDate] = useState([new Date()])
        const [eDate, setEDate] = useState([new Date()])
        const [regionId, setRegionId] = useState('')
        const [areaId, setAreaId] = useState('')
        const [facilityId, setFacilityId] = useState('')
        const [status, setStatus] = useState('')
        const [postedBy, setPostedBy] = useState('')

        const [regionList, setRegionList] = useState([])
        const [areaList, setAreaList] = useState([])
        const [facilityList, setFacilityList] = useState([]);
        const [statusList, setStatusList] = useState(['Open','Pending Approval','Closed']);
        const [staffList, setStaffList] = useState([]);

        const fetchData = () => {
            
          axios.get(`${url.FACILITIES}`, Config).then((r)=>{ 
            setFacilityList(r.data);  
          }).catch((e)=>{  console.log(e)});
            const ldata = {}
            axios.post(`${url.USERSFILTER}`, JSON.stringify(ldata), Config).then((r)=>{
                setStaffList(r.data)
            }).catch((e)=>{console.log(e);})
            const obj = JSON.parse(localStorage.getItem("authWTUser"));
            setPostedBy(obj.id)
            const data = {
              id        : "",
              startDate : formatDate(sDate[0]),
              endDate   : formatDate(eDate[0]),
              regionId  : "",
              areaId    : "",
              facilityId: "",
              status    : "",
              postedBy  : obj.id   
            } 
            setIsloading(true)
            axios.post(url.PRODUCTIONFILTER, JSON.stringify(data), Config).then((r)=>{  
              setDataList(r.data);
              setIsloading(false);
            }).catch((e)=>{  console.log(e); setIsloading(false); });
        }

        const handleGetAreasFromRegion = (r) =>{
          axios.get(`${url.AREAS}?region?${r}`, Config).then((r)=>{
            setAreaList(r.data)
          }).catch((e)=>{console.log(e)})
        }

        const handleGetFacilitiesFromArea = (a) =>{
          axios.get(`${url.FACILITIES}?area?${a}`, Config).then((r)=>{ 
            setFacilityList(r.data);  
          }).catch((e)=>{  console.log(e)});
        }
        useEffect(() => {
          fetchData();
        },[]);

        const handleFilterData = () => {

            const data = {
              id        : '',
              startDate : formatDate(sDate[0]),
              endDate   : formatDate(eDate[0]),
              regionId  : regionId,
              areaId    : areaId,
              facilityId: facilityId,
              status    : status,
              postedBy  : postedBy   
            } 
            setIsloading(true)
            axios.post(url.PRODUCTIONFILTER, JSON.stringify(data), Config).then((r)=>{  
              setDataList(r.data); 
              setIsloading(false);
            }).catch((e)=>{  console.log(e); setIsloading(false); });
           
        }

        const handleClearSearch = () =>{
          setSDate([])
          setEDate([])
          setRegionId('')
          setAreaId('')
          setFacilityId('')
          setStatus('')
          setPostedBy('')
          const obj = JSON.parse(localStorage.getItem("authWTUser"));
          setPostedBy(obj.id)
          const data = {
            id        : "",
            startDate : "",
            endDate   : "",
            regionId  : "",
            areaId    : "",
            facilityId: "",
            status    : "",
            postedBy  : obj.id   
          } 
          setIsloading(true)
          axios.post(url.PRODUCTIONFILTER, JSON.stringify(data), Config).then((r)=>{  
            setDataList(r.data); 
            setIsloading(false);
          }).catch((e)=>{  console.log(e); setIsloading(false); });
        }
        const handleExport = () =>{
          const data = {
              id        : "",
              startDate : (sDate.length > 0) ? formatDate(sDate[0]) : "",
              endDate   : (eDate.length > 0) ? formatDate(eDate[0]) : "",
              regionId  : regionId,
              areaId    : areaId,
              facilityId: facilityId,
              status    : status,
              postedBy  : postedBy   
          }
          setIsloading(true)
          axios.post(`${url.PRODUCTIONREPORT}`, JSON.stringify(data), Config).then((r)=>{ 
            setDataList(r.data)
            const urlx = url.APACHE_URL + "attach/output.xlsx"
            axios({
              url: urlx,
              method: 'GET',
              responseType: 'blob',
            })
            .then((response) => {
               const url = window.URL.createObjectURL(new Blob([response.data]));
               const link = document.createElement('a');
               link.href = url;
               link.setAttribute('download', `Water-Production-Report.xlsx`);
               document.body.appendChild(link);
               link.click();
               document.body.removeChild(link);
               window.URL.revokeObjectURL(url);
             })
             .catch((error) => {
               console.error('Error downloading the file:', error);
             });
            setIsloading(false)
          }).catch((e)=>{  
            console.log(e); 
            setIsloading(false)
          });
        }
        const columns = [
        
        {
          dataField: 'date',
          text: 'Date',
          sort: true,
          formatter: dateFormatter
        },
        {
          dataField: 'documentNo',
          text: 'No',
          sort: true
        },
        /*{
          dataField: 'region',
          text: 'Region',
          sort: true
        },
        
        {
          dataField: 'area',
          text: 'Area',
          sort: true
        },*/
        {
          dataField: 'facility',
          text: 'Facility',
          sort: true
        },
        
        {
            dataField: 'facilityType',
            text: 'Out-Flow',
            sort: true,
            align:'center',
            headerStyle: { textAlign: 'center' }, 
            formatter:volFormatter
        },
        
        {
            dataField: 'volumes',
            text: 'Pumped entries',
            sort: true,
            align:'center',
            headerStyle: { textAlign: 'center' }, 
            formatter:paramsFormatter
        },
        {
            dataField: 'energy',
            text: 'Total Units',
            sort: true,
            align:'center',
            headerStyle: { textAlign: 'center' }, 
            formatter:energyFormatter
        }, 
        {
            dataField: 'chemicals',
            text: 'Chemicals used',
            sort: true,
            align:'center',
            headerStyle: { textAlign: 'center' }, 
            formatter:chemicalFormatter
        },
        {
            dataField: 'status',
            text: 'status',
            sort: true,
            align:'center',
            headerStyle: { textAlign: 'center' }, 
            formatter: statusFormatter
        },

        {
            dataField: "action",
            isDummyField: true,
            text: "",
            formatter: actionFormatter
        }];

        const defaultSorted = [{
          dataField: 'date',
          order: 'desc'
        }];
        function actionFormatter(cellContent, row){
          return(
            <>
              <Button
                type="button"
                color="info"
                className="btn-sm btn-rounded"
                onClick={()=>{ history.push(`/water-production-details/${encryptId(row.id)}`)}}>
                Details
              </Button>
            </>
          )
        }
        function volFormatter(cellContent, row){
          return(<span> {row.volumes.filter(obj => obj.stage === "Out-Flow").reduce((acc, obj) => acc + parseFloat(obj.volumes), 0)}</span>)
        }
        function statusFormatter(cellContent, row) {
          if (row.status == "Closed") {
            return (
              <div>
                  <Badge className="me-2 bg-success">
                  { cellContent }
                  </Badge>
              </div>
            );
          }else if(row.status == "Pending Approval"){
            return (
              <div>
                  <Badge className="me-2 bg-warning">
                  { cellContent }
                  </Badge>
              </div>
            );
          }else{
            return (
              <div>
                  <Badge className="me-2 bg-danger">
                  { cellContent }
                  </Badge>
              </div>
            );
          }
        }
        function paramsFormatter(cellContent, row){
            return(<span> {row.volumes.length}</span>)
        }
        function energyFormatter(cellContent, row){
            return(<span> {row.energy.reduce((sum, ener) => sum + parseFloat(ener.units), 0)}</span>)
        }
        function chemicalFormatter(cellContent, row){
            return(<span> {row.chemicals.length}</span>)
        }

        function dateFormatter(cellContent, row){
            return(<span> {formatDate(cellContent)}</span>)
        }

        return (
            <>
            <LoadingOverlay
              active={isloading}
              spinner={<BounceLoader />}
              text='Please wait...'
              >
                <div className="page-content">
                    <MetaTags>
                    <title>Water Production | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>

                        <Row>
                        <Col lg={12}>
                          <Card>
                          <h5 className="card-header bg-transparent border-bottom text-uppercase">Filter</h5>
                            <CardBody>
                              <Row className="justify-content-center mb-1">
                                  <Col md={2}>
                                        <div className="mb-3">
                                            <label>Start date</label>
                                            <Flatpickr
                                                className="form-control form-control-sm"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={sDate}
                                                onChange={(dates)=>setSDate(dates)}
                                              />
                                        </div>
                                  </Col>
                                  <Col md={2}>
                                        <div className="mb-3">
                                            <label>End date</label>
                                            <Flatpickr
                                                className="form-control form-control-sm"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={eDate}
                                                onChange={(dates)=>setEDate(dates)}
                                              />
                                            
                                        </div>
                                  </Col>
                                 {/* <Col md={2}>
                                        <div className="mb-3">
                                            <label>Region</label>
                                            <select className="form-select form-select-sm" value={regionId} onChange={(e)=>{setRegionId(e.target.value); handleGetAreasFromRegion(e.target.value)}}>
                                            <option value=''>All</option>
                                            {regionList.map((r,k)=>(
                                              <option key={k} value={r.id}>{r.region}</option>
                                            ))}
                                            </select>
                                            
                                        </div>
                                  </Col>
                                  <Col md={2}>
                                        <div className="mb-3">
                                            <label>Area</label>
                                            <select className="form-select form-select-sm" value={areaId} onChange={(e)=>{ setAreaId(e.target.value); handleGetFacilitiesFromArea(e.target.value)}} >
                                              <option value=''>All</option>
                                              {areaList.map((a,k)=>(
                                                <option key={k} value={a.id}>{a.name}</option>
                                              ))}
                                            </select>
                                            
                                        </div>
                                  </Col>
                                  */}
                                  <Col md={2}>
                                        <div className="mb-3">
                                            <label>Facility</label>
                                            <select className="form-select form-select-sm" value={facilityId} onChange={(e)=>{ setFacilityId(e.target.value)}} >
                                              <option value=''>All</option>
                                              {facilityList.map((f,k)=>(
                                                <option key={k} value={f.id}>{f.facility}</option>
                                              ))}
                                            </select>
                                            
                                        </div>
                                  </Col>
                                  <Col md={2}>
                                        <div className="mb-3">
                                            <label>Status</label>
                                            <select className="form-select form-select-sm" value={status} onChange={(e)=>{ setStatus(e.target.value)}} >
                                              <option value=''>All</option>
                                              {statusList.map((s,k)=>(
                                                <option key={k} value={s}>{s}</option>
                                              ))}
                                            </select>
                                            
                                        </div>
                                  </Col>
                                  <Col md={2}>
                                        <div className="mb-3">
                                            <label>Staff</label>
                                            <select className="form-select form-select-sm" value={postedBy} onChange={(e)=>{ setPostedBy(e.target.value)}} >
                                              <option value=''>All</option>
                                              {staffList.map((s,k)=>(
                                                <option key={k} value={s.id}>{s.name}</option>
                                              ))}
                                            </select>
                                            
                                        </div>
                                  </Col>
                              </Row>
                              <Row  className="justify-content-center mb-2 mt-3">
                                                <Col lg={2} className="mb-2"> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='primary'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleFilterData()}}
                                                      >
                                                        <i className="mdi mdi-magnify me-1" />
                                                        Search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className="mb-2"> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='info'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleExport()}}
                                                      >
                                                        <i className="mdi mdi-export me-1" />
                                                        Export to Excel
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className="mb-2"> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='warning'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClearSearch()}}
                                                      >
                                                        <i className="mdi mdi-notification-clear-all me-1" />
                                                        Reset search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2}> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='success'
                                                        className="btn btn-sm"
                                                        onClick={()=>{ history.push("/add-water-production")}}
                                                      >
                                                        <i className="mdi mdi-plus me-1" />
                                                        Add Data
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  
                                                </Row>
                                
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>  
                      <Row>             
                        <Col lg="12">
                        <Card>
                        <h5 className="card-header bg-transparent border-bottom text-uppercase">Data</h5>
                            <CardBody>
                            <CardTitle className="mb-4">&nbsp;</CardTitle>

                            {dataList && (dataList.length > 0) && (
                                <>
                         
                                
                                <ToolkitProvider
                                      keyField="id"
                                      data={ dataList }
                                      columns={ columns }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                                            
                                            <Row>
                                              <Col xl="12">
                                                <div className="table-responsive">
                                                <BootstrapTable 
                                                  keyField='id' 
                                                  data={ dataList } 
                                                  columns={ columns } 
                                                  striped
                                                  hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table-sm align-middle table-check" }
                                                    {...toolkitProps.baseProps}
                                                 
                                                  />
                                            </div>
                                            </Col>
                                            </Row>
                                      
                                            </React.Fragment>
                                            
                                      )
                                    }
                                  </ToolkitProvider>
                           
                               

                                </>
                            )}
                            {dataList && (dataList.length < 1) && (
                                <div className="text-center">
                                    <div className="mb-4">
                                    <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                    </div>
                                    <div>
                                    <h5>No Data Found</h5>
                                    <p className="text-muted">
                                            
                                    </p>
                                    </div>
                                </div>

                            )}
                            </CardBody>
                        </Card>
                        </Col>
                    </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }
    WaterProduction.propTypes = {
        csvProps: PropTypes.any,
        baseProps: PropTypes.any
      };
export default WaterProduction;